export const getFromStorage = (key: string, storageType: 'session' | 'local' = 'session'): string | null => {
  if (!key) {
    console.warn('Must specify a key when attempting to get from storage', key, storageType)
    return null
  }
  try {
    return storageType === 'session' ? sessionStorage.getItem(key) : localStorage.getItem(key)
  } catch (err) {
    console.warn('Could not access storage', storageType, err)
    return null
  }
}

export const setInStorage = (key: string, value: string, storageType: 'session' | 'local' = 'session'): string | null => {
  if (!key) {
    console.warn('Must specify a key when attempting to get from storage', key, storageType)
    return null
  }
  if (!value) {
    console.warn('Must specify a value when attempting to get from storage', key, storageType, value)
    return null
  }
  try {
    const storage = storageType === 'session' ? sessionStorage : localStorage
    storage.setItem(key, value)
    return storage.getItem(key)
  } catch (err) {
    console.warn('Could not access storage', storageType, err)
    return null
  }
}

/**
 * @returns { boolean } the item was successfully deleted from storage
 */
export const removeFromStorage = (key: string, storageType: 'session' | 'local' = 'session'): boolean => {
  if (!key) {
    console.warn('Must specify a key when attempting to remove from storage', key, storageType)
    return false
  }
  try {
    const storage = storageType === 'session' ? sessionStorage : localStorage
    storage.removeItem(key)
    return true
  } catch (err) {
    console.warn('Could not access storage', storageType, err)
    return false
  }
}
